import { BG_STYLES, BORDER_STYLES, COLORS, COMMON_STYLES, TEXT_STYLES, TYPOGRAPHY, VARIANTS_STYLES } from "@dehaat/dds";
import React, { useState } from "react";
import {
	View,
	Text,
	TextInput,
	StyleSheet,
	TextInputProps,
} from "react-native";

type Props = TextInputProps & {
	label?: string;
	containerStyle?: any;
};

export default function OutlinedInput({
	label,
	value,
	multiline,
	containerStyle,
	style,
	onFocus,
	onBlur,
	...rest
}: Props) {
	const [focused, setFocused] = useState(false);

	return (
		<View style={[COMMON_STYLES.fullWidth, containerStyle]}>
			{label && (
				<View style={[COMMON_STYLES.absolute, BG_STYLES.bgWhite,
				styles.labelWrapper]}>
					<Text style={[TYPOGRAPHY.CAPTION1, VARIANTS_STYLES.MEDIUM, TEXT_STYLES.textNeutral90,]}>
						{label}
					</Text>
				</View>
			)}
			<View
				style={[
					COMMON_STYLES.b1,
					BORDER_STYLES.borderNeutral20,
					BG_STYLES.bgWhite,
					styles.inputContainer,
					COMMON_STYLES["ph3/4"],
					COMMON_STYLES["pv3/4"],
					COMMON_STYLES.justifyCenter,
					styles.inputContainer,
					focused && styles.focusedBorder,
					multiline && styles.multilineContainer,
				]}
			>
				<TextInput
					{...rest}
					value={value}
					multiline={multiline}
					onFocus={(e) => {
						setFocused(true);
						onFocus?.(e);
					}}
					onBlur={(e) => {
						setFocused(false);
						onBlur?.(e);
					}}
					scrollEnabled={false}
					showsVerticalScrollIndicator={false}
					showsHorizontalScrollIndicator={false}
					style={[
						COMMON_STYLES.flex1,
						COMMON_STYLES.fullWidth,
						COMMON_STYLES.borderNone,
						COMMON_STYLES.p0,
						{
							textAlignVertical: multiline ? "top" : "center",
							margin: 0,
							outlineStyle: "none",
							outlineWidth: 0,
							outlineColor: "transparent",
							scrollbarWidth: "none",
							msOverflowStyle: "none",
						},
						style,
					]}
					placeholderTextColor={COLORS.neutral40}
				/>

			</View>
		</View>
	);
}

const styles = StyleSheet.create({
	inputContainer: {
		borderRadius: 10,
		minHeight: 48,
	},
	focusedBorder: {
		...BORDER_STYLES.borderPrimary100,
		...COMMON_STYLES.b1,
	},
	multilineContainer: {
		minHeight: 60,
		paddingVertical: 10,
		...COMMON_STYLES.alignItemsStart,
	},
	labelWrapper: {
		top: -10,
		left: 14,
		zIndex: 2,
	},
});
